import { useCallback, useEffect, useRef, useState } from "react";
import Home from "./Home";
import { Tooltip } from "client/CommonComponents";
import { useNavigate } from "react-router-dom";
import comment from '../../../../assets/images/Comments.png'
import { useDispatch, useSelector } from "react-redux";
import { getBulkOrderGridCount, getBulkOrderGridData } from "Store/OrderManagement/BulkOrderDashboard/BulkOrderDashboardAction";
import GridFiltersAction from "Store/Component/GridDataFilters/GridDataFiltersAction";
import { CustomDateFilterComponent, CustomDropdownFilterComponent, getOrderList, iconReturn } from "./HomeHelper";
import { getAssignedToList, getRequestedByList, getStatusList, getUpdatedByList } from "Store/OrderManagement/OrderGridDropdowns/OrderGridDropdownsAction";
import { useDebounce } from "client/CommonComponents/CustomDebounce/DebounceHook";
import moment from "moment";
import { getAssetType } from "Store/AssetManagement/AssetType/AssetTypeAction";
import { CONSTANTS } from "client/utils/constants";
import { COLUMN_FILTERS, HOME_ACTIVE_MENU } from "client/utils/constants/homeGridConstants";
import { setBulkOrderAttachments, setIsApprovalOverride, setOrderCartData, setOrderData, setSelectedCostCenter, setSelectedOrderType } from "Store/Component/BulkOrder/BulkOrderAction";
import { GetOnOrderIdClickedUrl } from "../../mainUtil";
import { setSaveBulkOrder } from "Store/OrderManagement/BulkOrderSave/BulkOrderSaveAction";
import { getBulkOrderCostCenter } from "Store/Organization/CostCenters/CostCentersAction";
import orderDispatch from "Store/OrderManagement/Order/OrderDispatch";
import userProfileSelectors from '../../../../../redux/UserProfile/selectors';
import { setBulkOrderById } from "Store/OrderManagement/BulkOrderById/BulkOrderByIdAction";
import { fetchGridPayload, formatPrice, removeEmptyValues } from "utils";
import { CustomTextFilterDiv } from "client/utils/RequisitionUtil";


const searchByOptions = [
  { value:'orderId',label:'Order#'},
  { value:'assetNo',label:'Asset#'},
  { value:'poNumber',label:'PO#'},
  { value:'unitBarcode',label:'Unit/Barcode #'},
];

const HomeContainer = () => {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const dispatchGetCartCount = orderDispatch.dispatchGetCartCount(dispatch);

  const [paginationData, setPaginationData] = useState<any>({})
  const [gridKey, setGridKey] = useState<number>(0)
  const [pagesCount, setPagesCount] = useState<number>(0)
  const [serverTotal, setServerTotal] = useState(0)
  const [sortData, setSortData] = useState<any>('')
  const [searchValue, setSearchValue] = useState('')
  const [dateRange, setDateRange] = useState<any>([]);
  const [gridData, setGridData] = useState([])
  const [orderList, setOrderList] = useState([])
  const [activeMenu, setActiveMenu] = useState(CONSTANTS.GRID_ACTIVE_MENU.TOTAL_ORDERS)
  const [showGrid, setShowGrid] = useState<boolean>(false)

  const orderDate = useRef<any>(null);
  const updatedDate = useRef<any>(null);
  const selectStatus = useRef("");
  const selectRequestType = useRef("");
  const selectCostCenter = useRef("");
  const selectRequestedBy = useRef('');
  const selectAssignedTo = useRef('');
  const selectUpdatedBy = useRef('');
  const orderPriceFilterRef = useRef<any>('');
  const [quantityFilter, setQuantityFilter] = useState<any>('')
  const [orderIdFilter, setOrderIdFilter] = useState<any>('')
  const [orderPriceFilter, setOrderPriceFilter] = useState<any>('')
  const [commentFilter, setCommentFilter] = useState<any>('')
  const [isTabChanged, setIsTabChanged] = useState<any>(false);
  const [globalSearchBy, setGlobalSearchBy] = useState<any>({ value:'orderId',label:'Order#'})
  const lastCommonSearchSignatureRef = useRef<string | null>(null)
  const lastColumnFilterSignatureRef = useRef<string | null>(null)
  const forceFirstPageForCommonSearchRef = useRef<boolean>(false)

  const statusDropdownList: any = useRef(null);
  const requestTypeDropdownList: any = useRef(null);
  const updatedByDropdownList: any = useRef(null);
  const assignedToDropdownList: any = useRef(null);
  const requestedByDropdownList: any = useRef(null)
  const costCenterDropdownList: any = useRef(null);

  const {
    cartNav,
    bulkOrderGridCount,
    bulkOrderGridData,
    bulkOrderGridFilters,
    statusList,
    costCenterList,
    requestedByList,
    assignedToList,
    updatedByList,
    requisitionTypeList,
    attachmentList,
    userDetails,
    bulkOrderTotalOrderFilters,
    bulkOrderPendingApprovalFilters,
    bulkOrderSavedOrderFilters,
    bulkOrderFleetProcessingGridFilters,
    bulkOrderCompletedGridFilters,
    bulkOrderReturnedGridFilters,
    bulkOrderRejectedGridFilters,
    bulkOrderCancelledGridFilters,
    isBulkOrderGridLoading,
    isBulkOrderGridCountsLoading,
    isDropDownsLoading
  }: any = useSelector(
    (state: any) => ({
      cartNav: state.MyOrder.setCartNav,
      bulkOrderGridCount: state.BulkOrderDashboardReducer.bulkOrderGridCount,
      bulkOrderGridData: state.BulkOrderDashboardReducer.bulkOrderGridData,
      bulkOrderGridFilters: state.GridFiltersReducer.bulkOrderGridFilters,
      statusList: state.OrderGridDropdownsReducer.statusList,
      costCenterList: state.CostCentersReducer.bulkOrderCostCenterList,
      requestedByList: state.OrderGridDropdownsReducer.requestedByList,
      assignedToList: state.OrderGridDropdownsReducer.assignedToList,
      updatedByList: state.OrderGridDropdownsReducer.updatedByList,
      requisitionTypeList: state.AssetManagement.AssetType,
      attachmentList: state.BulkOrderReducer.attachmentList,
      userDetails: userProfileSelectors.getUserDetails(state),
      bulkOrderTotalOrderFilters: state.GridFiltersReducer.bulkOrderTotalOrderGridFilters,
      bulkOrderSavedOrderFilters: state.GridFiltersReducer.bulkOrderSavedOrderGridFilters,
      bulkOrderPendingApprovalFilters: state.GridFiltersReducer.bulkOrderPendingApprovalGridFilters,
      bulkOrderFleetProcessingGridFilters: state.GridFiltersReducer.bulkOrderFleetProcessingGridFilters,
      bulkOrderCompletedGridFilters: state.GridFiltersReducer.bulkOrderCompletedGridFilters,
      bulkOrderReturnedGridFilters: state.GridFiltersReducer.bulkOrderReturnedGridFilters,
      bulkOrderRejectedGridFilters: state.GridFiltersReducer.bulkOrderRejectedGridFilters,
      bulkOrderCancelledGridFilters: state.GridFiltersReducer.bulkOrderCancelledGridFilters,
      isBulkOrderGridLoading: state.BulkOrderDashboardReducer.isBulkOrderGridLoading,
      isBulkOrderGridCountsLoading: state.BulkOrderDashboardReducer.isBulkOrderGridCountsLoading,
      isDropDownsLoading: state.OrderGridDropdownsReducer.isDropDownsLoading
    })
  )

  useEffect(() => {
    document.getElementsByClassName('content-wrapper')[0].scrollTop = 0;
    dispatch(getBulkOrderGridCount());
    !(statusList?.length > 0) && dispatch(getStatusList())
    !(costCenterList?.length > 0) && dispatch(getBulkOrderCostCenter())
    !(requestedByList?.length > 0) && dispatch(getRequestedByList())
    !(updatedByList?.length > 0) && dispatch(getUpdatedByList())
    //!(requisitionTypeList?.length > 0) && 
    dispatch(getAssetType());
    dispatch(getAssignedToList())
  }, []);

  const setValues = () => {
    setSearchValue(bulkOrderGridFilters?.orderSearchBoxValue || '');
    setGlobalSearchBy(bulkOrderGridFilters?.globalSearchField ?? { value:'orderId',label:'Order#'})
    if (bulkOrderGridFilters?.dateRange?.length) {
      setDateRange(bulkOrderGridFilters?.dateRange)
    } else {
      setDateRange([]);
    }
    selectStatus.current = bulkOrderGridFilters?.status ?? '';
    selectRequestType.current = bulkOrderGridFilters?.orderRequestType ?? '';
    selectCostCenter.current = bulkOrderGridFilters?.costCenter ?? '';
    selectUpdatedBy.current = bulkOrderGridFilters?.updatedBy ?? '';
    selectAssignedTo.current = bulkOrderGridFilters?.assignedTo ?? '';
    selectRequestedBy.current = bulkOrderGridFilters?.requestedBy ?? '';
    orderDate.current = bulkOrderGridFilters?.orderDate ? new Date(bulkOrderGridFilters?.orderDate) : null;
    updatedDate.current = bulkOrderGridFilters?.updatedDate ? new Date(bulkOrderGridFilters?.updatedDate) : null;
    orderPriceFilterRef.current = bulkOrderGridFilters?.orderPrice ?? ''
  }

  useEffect(() => {
    dispatchGetCartCount(userDetails?.emailId)
    setShowGrid(true);
    let activeMenuval = bulkOrderGridFilters?.activeMenu ?? CONSTANTS.GRID_ACTIVE_MENU.TOTAL_ORDERS
    setActiveMenu(activeMenuval)
    if (activeMenuval === CONSTANTS.GRID_ACTIVE_MENU.TOTAL_ORDERS) {
      bulkOrderTotalOrderFilters.activeMenu = CONSTANTS.GRID_ACTIVE_MENU.TOTAL_ORDERS
      dispatch(GridFiltersAction.setBulkOrderGridFilters(bulkOrderTotalOrderFilters))
    } else if (activeMenuval === CONSTANTS.GRID_ACTIVE_MENU.SAVED) {
      bulkOrderSavedOrderFilters.activeMenu = CONSTANTS.GRID_ACTIVE_MENU.SAVED
      dispatch(GridFiltersAction.setBulkOrderGridFilters(bulkOrderSavedOrderFilters))
    } else if (activeMenuval === CONSTANTS.GRID_ACTIVE_MENU.PENDING_APPROVAL) {
      bulkOrderPendingApprovalFilters.activeMenu = CONSTANTS.GRID_ACTIVE_MENU.PENDING_APPROVAL
      dispatch(GridFiltersAction.setBulkOrderGridFilters(bulkOrderPendingApprovalFilters))
    } else if (activeMenuval === CONSTANTS.GRID_ACTIVE_MENU.FLEET_PROCESSING) {
      bulkOrderFleetProcessingGridFilters.activeMenu = CONSTANTS.GRID_ACTIVE_MENU.FLEET_PROCESSING
      dispatch(GridFiltersAction.setBulkOrderGridFilters(bulkOrderFleetProcessingGridFilters))
    } else if (activeMenuval === CONSTANTS.GRID_ACTIVE_MENU.COMPLETED) {
      bulkOrderCompletedGridFilters.activeMenu = CONSTANTS.GRID_ACTIVE_MENU.COMPLETED
      dispatch(GridFiltersAction.setBulkOrderGridFilters(bulkOrderCompletedGridFilters))
    } else if (activeMenuval === CONSTANTS.GRID_ACTIVE_MENU.RETURNED) {
      bulkOrderReturnedGridFilters.activeMenu = CONSTANTS.GRID_ACTIVE_MENU.RETURNED
      dispatch(GridFiltersAction.setBulkOrderGridFilters(bulkOrderReturnedGridFilters))
    } else if (activeMenuval === CONSTANTS.GRID_ACTIVE_MENU.REJECTED) {
      bulkOrderRejectedGridFilters.activeMenu = CONSTANTS.GRID_ACTIVE_MENU.REJECTED
      dispatch(GridFiltersAction.setBulkOrderGridFilters(bulkOrderRejectedGridFilters))
    } else if (activeMenuval === CONSTANTS.GRID_ACTIVE_MENU.CANCELLED) {
      bulkOrderCancelledGridFilters.activeMenu = CONSTANTS.GRID_ACTIVE_MENU.CANCELLED
      dispatch(GridFiltersAction.setBulkOrderGridFilters(bulkOrderCancelledGridFilters))
    }
    setValues()
  }, [])


  useEffect(() => {
    if (bulkOrderGridData?.data?.length) {
      const updatedOrderList = bulkOrderGridData?.data?.map((item: any) => ({
        ...item,
        orderDate: moment(item.orderDate).format("MM/DD/YYYY"),
        updatedDate: moment(item.updatedDate).format("MM/DD/YYYY"),
      }));
      setGridData(updatedOrderList);
    } else {
      setGridData([]);
    }
    setServerTotal(bulkOrderGridData?.totalRecords)
  }, [bulkOrderGridData])

  useEffect(() => {
    const list: any = getOrderList(bulkOrderGridCount);
    setOrderList(list);
  }, [bulkOrderGridCount])

  useEffect(() => {
    const dropdownList: any = statusList?.map((item: any) => {
      return { label: item.text, key: item.value, ...item }
    })
    statusDropdownList.current = dropdownList
  }, [statusList])

  useEffect(() => {
    const list = requisitionTypeList?.filter((i: any) => {
      return i.orderRequestType !== "Select Requisition Type";
    })
    requestTypeDropdownList.current = list?.filter((item: any) => item.orderRequestType === CONSTANTS.MANAGED_EQUIPMENT || item.orderRequestType === CONSTANTS.PRODUCTION_VEHICLE || item.orderRequestType === CONSTANTS.MANAGEMENT_VEHICLE)?.map((item?: any) => {
      return { label: item.orderRequestType, value: item?.orderRequestType, ...item }
    })
  }, [requisitionTypeList])

  useEffect(() => {
    const dropdownList: any = costCenterList?.map((item: any) => {
      return { label: item.text, key: item.value, ...item }
    })
    costCenterDropdownList.current = dropdownList
  }, [costCenterList])

  useEffect(() => {
    const dropdownList: any = requestedByList?.map((item: any) => {
      return { label: item.text, key: item.value, ...item }
    })
    requestedByDropdownList.current = dropdownList
  }, [requestedByList])

  useEffect(() => {
    const dropdownList = assignedToList?.map((item: any) => {
      return { label: item.text, key: item.value, ...item }
    })
    assignedToDropdownList.current = dropdownList
  }, [assignedToList])

  useEffect(() => {
    const dropdownList = updatedByList?.map((item: any) => {
      return { label: item.text, key: item.value, ...item }
    })
    updatedByDropdownList.current = dropdownList
  }, [updatedByList])

  useEffect(() => {
    setQuantityFilter(bulkOrderGridFilters?.quantity)
  }, [bulkOrderGridFilters?.quantity])

  useEffect(() => {
    setOrderIdFilter(bulkOrderGridFilters?.orderId)
  }, [bulkOrderGridFilters?.orderId])

  useEffect(() => {
    setOrderPriceFilter(bulkOrderGridFilters?.orderPrice)
  }, [bulkOrderGridFilters?.orderPrice])

  useEffect(() => {
    setCommentFilter(bulkOrderGridFilters?.comment)
  }, [bulkOrderGridFilters?.comment])

  useEffect(() => {
    if (serverTotal && paginationData?.pageSize) {
      let pageSize = paginationData?.pageSize
      let tempPageCount = serverTotal > pageSize ? Math.ceil(serverTotal / pageSize - 1) : 0
      setPagesCount(tempPageCount)
    }
  }, [serverTotal, paginationData?.pageSize])

  const CreateBulkOrderClick = (e: any) => {
    e.preventDefault();
    dispatch(setOrderCartData([]))
    dispatch(setSelectedCostCenter({}))
    dispatch(setSelectedOrderType({}))
    dispatch(setIsApprovalOverride(false))
    dispatch(setOrderData([]))
    dispatch(setSaveBulkOrder({}))
    dispatch(setBulkOrderAttachments([], attachmentList?.requestIndex))
    navigate('createnewbulkorder')
  }

  const onSearchOrder = (e: any, isKeyPress?: any) => {
    setSearchValue((isKeyPress ? e : e?.target?.value))
    dispatch(GridFiltersAction.setBulkOrderGridFilters({ orderSearchBoxValue: (isKeyPress ? e : e?.target?.value),  globalSearchField: globalSearchBy}))
  }

  const onDateRangeChange = (e: any) => {
    setDateRange(e);
    dispatch(GridFiltersAction.setBulkOrderGridFilters({ dateRange: e }))
  }

  const setFilters = (value: any) => {
    if (value !== '{}') {
      dispatch(GridFiltersAction.setBulkOrderGridFilters(value))
    }
  }

  const getFilteredValues = () => {
    let filteredValues: any = [];
    if (orderDate.current != null) {
      filteredValues.push({ 'field': COLUMN_FILTERS.ORDER_DATE, 'value': moment(new Date(orderDate.current)).format('YYYY-MM-DD') })
    }
    if (updatedDate.current != null) {
      filteredValues.push({ 'field': COLUMN_FILTERS.UPDATED_DATE, 'value': moment(new Date(updatedDate.current)).format('YYYY-MM-DD') })
    }
    if (selectStatus.current != "") {
      filteredValues.push({ 'field': COLUMN_FILTERS.STATUS, 'value': selectStatus.current })
    }
    if (selectRequestType.current != "") {
      filteredValues.push({ 'field': COLUMN_FILTERS.REQUEST_TYPE, 'value': selectRequestType.current })
    }
    if (selectUpdatedBy.current != "") {
      const findValue = updatedByDropdownList?.current?.find((item: any) => item.label === selectUpdatedBy.current)
      filteredValues.push({ 'field': COLUMN_FILTERS.UPDATED_BY, 'value': findValue?.value })
    }
    if (selectAssignedTo.current != "") {
      const findValue = assignedToDropdownList?.current?.find((item: any) => item.label === selectAssignedTo.current)
      filteredValues.push({ 'field': COLUMN_FILTERS.ASSIGNED_TO, 'value': findValue?.value })
    }
    if (selectRequestedBy.current != "") {
      const findValue = requestedByDropdownList?.current?.find((item: any) => item.label === selectRequestedBy.current)
      filteredValues.push({ 'field': COLUMN_FILTERS.REQUESTED_BY, 'value': findValue?.value })
    }
    if (selectCostCenter.current != "") {
      const findValue = costCenterDropdownList?.current?.find((item: any) => item.label === selectCostCenter.current)
      filteredValues.push({ 'field': COLUMN_FILTERS.COST_CENTER, 'value': findValue?.value })
    }
    if (quantityFilter != "" && quantityFilter) {
      filteredValues.push({ 'field': COLUMN_FILTERS.QUANTITY, 'value': quantityFilter })
    }
    if (orderIdFilter != "" && orderIdFilter) {
      filteredValues.push({ 'field': COLUMN_FILTERS.ORDER_ID, 'value': orderIdFilter })
    }
    if (orderPriceFilter != "" && orderPriceFilter) {
      filteredValues.push({ 'field': COLUMN_FILTERS.PRICE, 'value': orderPriceFilter })
    }
    if (commentFilter != "" && commentFilter) {
      filteredValues.push({ 'field': COLUMN_FILTERS.COMMENT, 'value': commentFilter })
    }
    return filteredValues;
  }

  const debounceObject = [
    paginationData, activeMenu, searchValue, dateRange, orderDate, updatedDate, selectStatus, selectRequestType,
    selectUpdatedBy, selectAssignedTo, selectRequestedBy, selectCostCenter, quantityFilter, orderIdFilter, orderPriceFilter,
    commentFilter, sortData
  ]
  const globalDebounce = useDebounce(debounceObject, 500)

  const syncPaginationToFirstPage = useCallback(() => {
    setPaginationData((prev: any) => {
      const nextPaginationData = { ...prev, pageIndex: 0 }
      dispatch(GridFiltersAction.setBulkOrderGridFilters({ paginationData: nextPaginationData }))
      return nextPaginationData
    })
  }, [dispatch])

  const fetchGridData = (pageOverride?: number) => {
    const normalizedSearchText = `${searchValue ?? ''}`.trim()
    const currentCommonSearchSignature = `${globalSearchBy?.value ?? ''}::${normalizedSearchText}`
    const currentColumnFilters = getFilteredValues()
    const currentColumnFilterSignature = JSON.stringify(currentColumnFilters)
    const shouldForceFirstPageForCommonSearch = pageOverride === undefined && forceFirstPageForCommonSearchRef.current
    const resolvedPageNumber = pageOverride !== undefined
      ? pageOverride
      : shouldForceFirstPageForCommonSearch
        ? 1
        : (paginationData?.pageIndex != undefined ? paginationData?.pageIndex + 1 : undefined)
    let payload: any = {
      "pageNumber": resolvedPageNumber,
      "pageSize": paginationData?.pageSize,
      "columnFilters": currentColumnFilters,
      "gridFilterName": activeMenu,
      "loggedInMail" : userDetails?.emailId
    }

    payload = fetchGridPayload(payload, dateRange, searchValue, sortData, true, globalSearchBy?.value)

    lastCommonSearchSignatureRef.current = currentCommonSearchSignature
  lastColumnFilterSignatureRef.current = currentColumnFilterSignature
    forceFirstPageForCommonSearchRef.current = false


    if (payload.pageNumber && payload.pageSize) {
      dispatch(getBulkOrderGridData(payload));
    }
  }

  useEffect(() => {
    const normalizedSearchText = `${searchValue ?? ''}`.trim()
    const currentCommonSearchSignature = `${globalSearchBy?.value ?? ''}::${normalizedSearchText}`
    const currentColumnFilters = getFilteredValues()
    const currentColumnFilterSignature = JSON.stringify(currentColumnFilters)
    const currentPageIndex = paginationData?.pageIndex ?? 0
    if (lastCommonSearchSignatureRef.current === null || lastColumnFilterSignatureRef.current === null) {
      lastCommonSearchSignatureRef.current = currentCommonSearchSignature
      lastColumnFilterSignatureRef.current = currentColumnFilterSignature
      return
    }
    const hasCommonSearchChanged = currentCommonSearchSignature !== lastCommonSearchSignatureRef.current
    const hasColumnFilterChanged = currentColumnFilterSignature !== lastColumnFilterSignatureRef.current

    if (hasCommonSearchChanged || hasColumnFilterChanged) {
      forceFirstPageForCommonSearchRef.current = true
    }

    if ((hasCommonSearchChanged || hasColumnFilterChanged) && currentPageIndex !== 0) {
      syncPaginationToFirstPage()
      setGridKey((k: number) => k + 1)
    }
  }, [globalDebounce, paginationData?.pageIndex, syncPaginationToFirstPage])

  useEffect(() => {
    fetchGridData()
  }, [globalDebounce])

  const fetchAction = useCallback((fetchData: any) => {
    if (fetchData.action && fetchData.action === "paging") {
      setPaginationData(fetchData.data)
    }
    if (fetchData.action && fetchData.action === "sorting") {
      setSortData(fetchData.data[0]);
    }
  }, [])
  const clearFilterValues = {
    orderId: '',
    status: '',
    orderDate: null,
    regionName: '',
    costCenter: '',
    quantity: '',
    orderRequestType: '',
    requestedBy: '',
    updatedDate: null,
    updatedBy: '',
    assignedTo: '',
    orderPrice: '',
    frsOrderNumber: '',
    comment: '',
    orderSearchBoxValue: '',
    dateRange: [],
    fleetItemStatus: '',
    globalSearchField: null
  }

  const handleFilterClear = () => {
    if (bulkOrderGridFilters?.activeMenu === CONSTANTS.GRID_ACTIVE_MENU.TOTAL_ORDERS) {
      dispatch(GridFiltersAction.setBulkOrderTotalOrderFilters({}))
   } else if (bulkOrderGridFilters?.activeMenu === CONSTANTS.GRID_ACTIVE_MENU.SAVED) {
    dispatch(GridFiltersAction.setBulkOrderSavedOrderFilters({}))
   } else if (bulkOrderGridFilters?.activeMenu === CONSTANTS.GRID_ACTIVE_MENU.PENDING_APPROVAL) {
    dispatch(GridFiltersAction.setBulkOrderPendingApprovalFilters({}))
   } else if (bulkOrderGridFilters?.activeMenu === CONSTANTS.GRID_ACTIVE_MENU.FLEET_PROCESSING) {
    dispatch(GridFiltersAction.setBulkOrderFleetProcessingFilters({}))
   } else if (bulkOrderGridFilters?.activeMenu === CONSTANTS.GRID_ACTIVE_MENU.COMPLETED) {
    dispatch(GridFiltersAction?.setBulkOrderCompletedFilters({}))
   } else if (bulkOrderGridFilters?.activeMenu === CONSTANTS.GRID_ACTIVE_MENU.RETURNED) {
    dispatch(GridFiltersAction.setBulkOrderReturnedFilters({}))
   } else if (bulkOrderGridFilters?.activeMenu === CONSTANTS.GRID_ACTIVE_MENU.REJECTED) {
    dispatch(GridFiltersAction.setBulkOrderRejectedFilters({}))
   } else if (bulkOrderGridFilters?.activeMenu === CONSTANTS.GRID_ACTIVE_MENU.CANCELLED) {
    dispatch(GridFiltersAction.setBulkOrderCancelledFilters({}))
   }
    setShowGrid(false);
    setSearchValue('')
    setGlobalSearchBy({ value:'orderId',label:'Order#'})
    setDateRange([])
    orderDate.current = null
    updatedDate.current = null
    selectStatus.current = ''
    selectRequestType.current = ''
    selectCostCenter.current = ''
    selectRequestedBy.current = ''
    selectAssignedTo.current = ''
    selectUpdatedBy.current = ''
    dispatch(GridFiltersAction.setBulkOrderGridFilters(clearFilterValues));
    setTimeout(() => {
      setShowGrid(true);
    })
  }

  const setActiveMenuData = (activeMenu: any) => {
    if (activeMenu === CONSTANTS.GRID_ACTIVE_MENU.TOTAL_ORDERS) {
      removeEmptyValues(bulkOrderTotalOrderFilters, clearFilterValues)
      bulkOrderTotalOrderFilters.activeMenu = CONSTANTS.GRID_ACTIVE_MENU.TOTAL_ORDERS
      dispatch(GridFiltersAction.setBulkOrderGridFilters(bulkOrderTotalOrderFilters))
    } else if (activeMenu === CONSTANTS.GRID_ACTIVE_MENU.SAVED) {
      removeEmptyValues(bulkOrderSavedOrderFilters, clearFilterValues)
      bulkOrderSavedOrderFilters.activeMenu = CONSTANTS.GRID_ACTIVE_MENU.SAVED
      dispatch(GridFiltersAction.setBulkOrderGridFilters(bulkOrderSavedOrderFilters))
    } else if (activeMenu === CONSTANTS.GRID_ACTIVE_MENU.PENDING_APPROVAL) {
      removeEmptyValues(bulkOrderPendingApprovalFilters, clearFilterValues)
      bulkOrderPendingApprovalFilters.activeMenu = CONSTANTS.GRID_ACTIVE_MENU.PENDING_APPROVAL
      dispatch(GridFiltersAction.setBulkOrderGridFilters(bulkOrderPendingApprovalFilters))
    } else if (activeMenu === CONSTANTS.GRID_ACTIVE_MENU.FLEET_PROCESSING) {
      removeEmptyValues(bulkOrderFleetProcessingGridFilters, clearFilterValues)
      bulkOrderFleetProcessingGridFilters.activeMenu = CONSTANTS.GRID_ACTIVE_MENU.FLEET_PROCESSING
      dispatch(GridFiltersAction.setBulkOrderGridFilters(bulkOrderFleetProcessingGridFilters))
    } else if (activeMenu === CONSTANTS.GRID_ACTIVE_MENU.COMPLETED) {
      removeEmptyValues(bulkOrderCompletedGridFilters, clearFilterValues)
      bulkOrderCompletedGridFilters.activeMenu = CONSTANTS.GRID_ACTIVE_MENU.COMPLETED
      dispatch(GridFiltersAction.setBulkOrderGridFilters(bulkOrderCompletedGridFilters))
    } else if (activeMenu === CONSTANTS.GRID_ACTIVE_MENU.RETURNED) {
      removeEmptyValues(bulkOrderReturnedGridFilters, clearFilterValues)
      bulkOrderReturnedGridFilters.activeMenu = CONSTANTS.GRID_ACTIVE_MENU.RETURNED
      dispatch(GridFiltersAction.setBulkOrderGridFilters(bulkOrderReturnedGridFilters))
    } else if (activeMenu === CONSTANTS.GRID_ACTIVE_MENU.REJECTED) {
      removeEmptyValues(bulkOrderRejectedGridFilters, clearFilterValues)
      bulkOrderRejectedGridFilters.activeMenu = CONSTANTS.GRID_ACTIVE_MENU.REJECTED
      dispatch(GridFiltersAction.setBulkOrderGridFilters(bulkOrderRejectedGridFilters))
    } else if (activeMenu === CONSTANTS.GRID_ACTIVE_MENU.CANCELLED) {
      removeEmptyValues(bulkOrderCancelledGridFilters, clearFilterValues)
      bulkOrderCancelledGridFilters.activeMenu = CONSTANTS.GRID_ACTIVE_MENU.CANCELLED
      dispatch(GridFiltersAction.setBulkOrderGridFilters(bulkOrderCancelledGridFilters))
    }
  }

  useEffect(() => {
    if (isTabChanged) {
      setIsTabChanged(false)
      delete bulkOrderGridFilters.orderSearchBoxValue
      delete bulkOrderGridFilters.globalSearchField
      delete bulkOrderGridFilters.orderId
      delete bulkOrderGridFilters.orderPrice
      delete bulkOrderGridFilters.frsOrderNumber
      delete bulkOrderGridFilters.comment
    }
    if (bulkOrderGridFilters?.activeMenu === CONSTANTS.GRID_ACTIVE_MENU.TOTAL_ORDERS) {
      dispatch(GridFiltersAction.setBulkOrderTotalOrderFilters(bulkOrderGridFilters))
    } else if (bulkOrderGridFilters?.activeMenu === CONSTANTS.GRID_ACTIVE_MENU.SAVED) {
      dispatch(GridFiltersAction.setBulkOrderSavedOrderFilters(bulkOrderGridFilters))
    } else if (bulkOrderGridFilters?.activeMenu === CONSTANTS.GRID_ACTIVE_MENU.PENDING_APPROVAL) {
      dispatch(GridFiltersAction.setBulkOrderPendingApprovalFilters(bulkOrderGridFilters))
    } else if (bulkOrderGridFilters?.activeMenu === CONSTANTS.GRID_ACTIVE_MENU.FLEET_PROCESSING) {
      dispatch(GridFiltersAction?.setBulkOrderFleetProcessingFilters(bulkOrderGridFilters))
    } else if (bulkOrderGridFilters?.activeMenu === CONSTANTS.GRID_ACTIVE_MENU.COMPLETED) {
      dispatch(GridFiltersAction?.setBulkOrderCompletedFilters(bulkOrderGridFilters))
    } else if (bulkOrderGridFilters?.activeMenu === CONSTANTS.GRID_ACTIVE_MENU.RETURNED) {
      dispatch(GridFiltersAction.setBulkOrderReturnedFilters(bulkOrderGridFilters))
    } else if (bulkOrderGridFilters?.activeMenu === CONSTANTS.GRID_ACTIVE_MENU.REJECTED) {
      dispatch(GridFiltersAction.setBulkOrderRejectedFilters(bulkOrderGridFilters))
    } else if (bulkOrderGridFilters?.activeMenu === CONSTANTS.GRID_ACTIVE_MENU.CANCELLED) {
      dispatch(GridFiltersAction.setBulkOrderCancelledFilters(bulkOrderGridFilters))
    }
    setValues()
  }, [bulkOrderGridFilters])

  const handleClick = (item: any) => {
    setIsTabChanged(true)
    setActiveMenuData(item)
    setActiveMenu(item)
    dispatch(GridFiltersAction.setBulkOrderGridFilters({ activeMenu: item }))
    setShowGrid(false);
    setTimeout(() => {
      setShowGrid(true);
    })
  }

  const onOrderIdClicked = (ev: any, row: any) => {
    ev.preventDefault(); // don't navigate
    dispatch(setBulkOrderById([]))
    let navigationUrl : any
    const rowData = row?.rowData
    let activeMenuTemp = (activeMenu == CONSTANTS.GRID_ACTIVE_MENU.PENDING_APPROVAL ? HOME_ACTIVE_MENU.PENDING_APPROVALS_ORDER :  CONSTANTS.BULK_ORDER)
    navigationUrl =  GetOnOrderIdClickedUrl(rowData?.status, CONSTANTS?.BULK_ORDER_GRID, rowData?.orderId, rowData?.isBulkOrder, CONSTANTS.BULK_ORDER, activeMenuTemp)
    navigate(navigationUrl);
  }

  const orderPriceFilterOnchange = (e: any) => {
    setOrderPriceFilter(e.target.value)
    orderPriceFilterRef.current = e.target.value
    if (activeMenu === CONSTANTS.GRID_ACTIVE_MENU.TOTAL_ORDERS) {
      dispatch(GridFiltersAction.setBulkOrderGridFilters({ orderPrice: e.target.value }))
    } else if (activeMenu === CONSTANTS.GRID_ACTIVE_MENU.SAVED) {
      dispatch(GridFiltersAction.setBulkOrderGridFilters({ orderPrice: e.target.value }))
    } else if (activeMenu === CONSTANTS.GRID_ACTIVE_MENU.PENDING_APPROVAL) {
      dispatch(GridFiltersAction.setBulkOrderGridFilters({ orderPrice: e.target.value }))
    } else if (activeMenu === CONSTANTS.GRID_ACTIVE_MENU.FLEET_PROCESSING) {
      dispatch(GridFiltersAction.setBulkOrderGridFilters({ orderPrice: e.target.value }))
    } else if (activeMenu === CONSTANTS.GRID_ACTIVE_MENU.COMPLETED) {
      dispatch(GridFiltersAction.setBulkOrderGridFilters({ orderPrice: e.target.value }))
    } else if (activeMenu === CONSTANTS.GRID_ACTIVE_MENU.RETURNED) {
      dispatch(GridFiltersAction.setBulkOrderGridFilters({ orderPrice: e.target.value }))
    } else if (activeMenu === CONSTANTS.GRID_ACTIVE_MENU.REJECTED) {
      dispatch(GridFiltersAction.setBulkOrderGridFilters({ orderPrice: e.target.value }))
    } else if (activeMenu === CONSTANTS.GRID_ACTIVE_MENU.CANCELLED) {
      dispatch(GridFiltersAction.setBulkOrderGridFilters({ orderPrice: e.target.value }))
    }
  }


  const bulkOrderColumn = [
    {
      key: "orderId",
      title: activeMenu === CONSTANTS.GRID_ACTIVE_MENU.SAVED ? "Draft" : "LEADR Order #",
      Cell: (row: any) => {
        return (
          <a
            href="/"
            onClick={(e: any) => {
              onOrderIdClicked(e, row);
            }}
            className="order-link-id"
          >
            {row.rowData.status === "Unsubmitted"
              ? "Draft"
              : row.rowData.orderId}
          </a>
        );
      },
      width: 90,
      filterRowValue: bulkOrderGridFilters?.orderId ?? ''
    },
    {
      key: "status",
      title: "Status",
      Cell: (row: any) => {
        return (
          <a
            href="/"
            onClick={(e: any) => {
              // props?.onOrderIdClicked(e, row);
            }}
            className="status"
          > {iconReturn(row.rowData.status)} <span className={`${row.rowData.status == 'Fleet Processing' ? 'status-text fleetprocessing' : 'status-text'}`}>{row.rowData.status}</span></a>
        );
      },
      width: 140,
      FilterCell: (props: any) => (
        <CustomDropdownFilterComponent {...props} options={statusDropdownList.current} setDropdown={selectStatus} />
      ),
    },
    {
      key: "orderDate",
      title: "Order Date",
      Cell: (row: any) => {
        return (
          <p className="dateSubmitted">
            {row.rowData.orderDate
              ? moment(row.rowData.orderDate).format("MM/DD/YYYY")
              : ""}
          </p>
        );
      },
      FilterCell: (props: any) => (<CustomDateFilterComponent {...props} setDate={orderDate} />),
      width: 120
    },
    {
      key: "costCenter",
      title: "Cost Center",
      width: 160,
      FilterCell: (props: any) => (
        <CustomDropdownFilterComponent {...props} options={costCenterDropdownList.current} setDropdown={selectCostCenter} />
      )
    },
    {
      key: "quantity",
      title: "Qty",
      width: 60,
      filterRowValue: bulkOrderGridFilters?.quantity ?? ''
    },
    {
      key: "orderRequestType",
      title: "Order Type",
      width: 140,
      Cell: (typeRow: any) => {
        const requesttype = typeRow.rowData.orderRequestType?.toString();
        return (
          <p>{requesttype?.replaceAll(",", " | ")}</p>
        )
      },
      FilterCell: (props: any) => (
        <CustomDropdownFilterComponent{...props} options={requestTypeDropdownList.current} setDropdown={selectRequestType} />
      )
    },
    {
      key: "requestedBy",
      title: "Created By",
      width: 120,
      FilterCell: (props: any) => (
        <CustomDropdownFilterComponent{...props} options={requestedByDropdownList.current} setDropdown={selectRequestedBy} />
      )
    },
    {
      key: "updatedDate",
      title: "Updated Date",
      width: 120,
      Cell: (row: any) => {
        return (
          <p className="dateSubmitted">
            {row.rowData.updatedDate
              ? moment(row.rowData.updatedDate).format("MM/DD/YYYY")
              : ""}
          </p>
        );
      },
      FilterCell: (props: any) => (<CustomDateFilterComponent {...props} setDate={updatedDate} />)
    },
    {
      key: "updatedBy",
      title: "Updated By",
      width: 120,
      FilterCell: (props: any) => (
        <CustomDropdownFilterComponent{...props} options={updatedByDropdownList.current} setDropdown={selectUpdatedBy} />
      )
    },
    {
      key: "assignedTo",
      title: "Assigned To",
      width: 120,
      FilterCell: (props: any) => (
        <CustomDropdownFilterComponent{...props} options={assignedToDropdownList.current} setDropdown={selectAssignedTo} />
      )
    },
    {
      key: "orderPrice",
      title: "Order Price ($)",
      Cell: (orderPriceRow: any) => {
        return (
          <span>
            {" "}
            {orderPriceRow?.rowData?.orderPrice != null ? (
              <p>{'$ ' + formatPrice(orderPriceRow?.rowData?.orderPrice || 0, 2) || '-'}</p>
            ) : (
              ""
            )}
          </span>
        );
      },
      FilterCell: () => {
        return <CustomTextFilterDiv orderPriceFilter = {orderPriceFilterRef.current} onChange = {(e: any) => orderPriceFilterOnchange(e)} />;
      },
      width: 90
    },
    {
      key: "comment",
      title: "Comments",
      width: 80,
      Cell: (commentsRow: any) => {
        const commentsContent = commentsRow?.rowData?.comment;
        const commentsTooltipProps: any = {
          onRenderContent: () => {
            if (typeof commentsContent === "string") {
              return <div>{commentsContent}</div>;
            } else if (Array?.isArray(commentsContent)) {
              return (
                <div className="tooltipConversation">
                  {commentsContent?.map((item: any, index: number) => {
                    return (
                      <>
                        <div
                          className={`chat ${item.type === "reply" ? "reply" : "message"
                            }`}
                          key={index}
                        >
                          <p className="author">{item?.author}</p>
                          <div className="comment">
                            <p>
                              <span className="blueText">OrderId &nbsp;</span>
                              {commentsRow?.rowData?.orderId}
                            </p>
                            <p className="comment_area">{item?.comment}</p>
                          </div>
                        </div>
                        <br />
                      </>
                    );
                  })}
                </div>
              );
            }
          },
        };
        return commentsRow?.rowData?.comment?.length > 0 ? (
          <Tooltip data-attribute="Home_container_Default_Tooltip">
            <div className="commentBlock">
              <img src={comment} alt="comment" className="comments" />
            </div>
          </Tooltip>
        ) : null;
      },
      filterRowValue: bulkOrderGridFilters?.comment ?? ''
    },
  ];

  const onGlobalSearchByChange = (value: any) => {
    setGlobalSearchBy(value)
    dispatch(GridFiltersAction.setBulkOrderGridFilters({ globalSearchField: value }))
  }

  const alreadyHasGridFilterValues = useCallback(() => {
    let isAlreadyHasValues = true
    let GridFilterValueTemp = bulkOrderGridFilters ? JSON.parse(JSON.stringify(bulkOrderGridFilters)) : []
    Object.keys(clearFilterValues)?.forEach((filterItem?: any) => {
      Object.keys(GridFilterValueTemp ?? {})?.forEach((gridItem?: any) => {
        if (filterItem == gridItem) {
          let val = gridItem
          if (GridFilterValueTemp[val] != "" && GridFilterValueTemp[val] != null && GridFilterValueTemp[val] != undefined && val != "dateRange" && val != "globalSearchField") {
            isAlreadyHasValues = false
          } else if (val == "dateRange") {
            if (GridFilterValueTemp[val]?.length) {
              isAlreadyHasValues = false
            }
          }
        }
      })
    })
    return isAlreadyHasValues
  }, [bulkOrderGridFilters])

  return <Home
    CreateBulkOrderClick={CreateBulkOrderClick}
    orderList={orderList}
    cartNav={cartNav}
    gridData={gridData}
    searchValue={searchValue}
    dateRange={dateRange}
    onSearchOrder={onSearchOrder}
    onDateRangeChange={onDateRangeChange}
    bulkOrderColumn={bulkOrderColumn}
    setFilters={setFilters}
    serverTotal={serverTotal}
    fetchAction={fetchAction}
    pagesCount={pagesCount}
    handleFilterClear={handleFilterClear}
    handleClick={handleClick}
    activeMenu={activeMenu}
    showGrid={showGrid}
    gridKey={gridKey}
    isBulkOrderGridLoading={isBulkOrderGridLoading}
    isBulkOrderGridCountsLoading={isBulkOrderGridCountsLoading}
    isDropDownsLoading={isDropDownsLoading}
    searchByOptions={searchByOptions}
    globalSearchBy={globalSearchBy}
    onGlobalSearchByChange={onGlobalSearchByChange}
    alreadyHasGridFilterValues = {alreadyHasGridFilterValues}
  />
}

export default HomeContainer;